import React, { useState, useEffect } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { WidgetModal } from "../../modules.widgets";

export function OrderPurchaseReceived({
    isOpen,
    onClose,
    detailsFromOrderPurchaseReceived,
}) {
    const [filename, setFilename] = useState("DetallePedido");

    const calculateTotals = () => {
        const totalBase = detailsFromOrderPurchaseReceived.reduce(
            (pv, cv) => pv + (Number(cv.base) || Number(cv.taxableAmount) || 0),
            0,
        );
        const totalIgv = detailsFromOrderPurchaseReceived.reduce(
            (pv, cv) => pv + (Number(cv.igv) || Number(cv.igvAmount) || 0),
            0,
        );
        const totalTotal = detailsFromOrderPurchaseReceived.reduce(
            (pv, cv) => pv + (Number(cv.total) || Number(cv.totalWithIgv) || 0),
            0,
        );
        return { totalBase, totalIgv, totalTotal };
    };

    const { totalBase, totalIgv, totalTotal } = calculateTotals();

    return (
        <WidgetModal isOpen={isOpen} onClose={onClose} title="Detalles del pedido" size="xl">
            <div className="px-6 py-4">
                <div className="overflow-x-auto">
                    <table
                        className="min-w-full text-sm border-separate border-spacing-0"
                        id="table-to-xls"
                    >
                        <thead className="bg-gray-100 dark:bg-gray-700">
                            <tr>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300">
                                    SKU
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300">
                                    PRODUCTO
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300">
                                    UND
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300">
                                    CANT.
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300">
                                    VALOR UNITARIO
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300">
                                    V. VENTA BRUTA
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300">
                                    %DSCTO
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300">
                                    VALOR DSCTO
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-300">
                                    V. VENTA NETA
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-green-600 dark:text-green-400">
                                    BASE
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-green-600 dark:text-green-400">
                                    IGV
                                </th>
                                <th className="px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600 text-green-600 dark:text-green-400">
                                    TOTAL
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {detailsFromOrderPurchaseReceived.map((item, index) => {
                                const sku = item.sku || "";
                                const productName = item.productName || "";
                                const unitName = item.unitName || "";
                                const quantity = item.quantity || 0;
                                const unitPrice = item.price || item.unitPrice || 0;
                                const grossAmount = item.amount || item.grossAmount || 0;
                                const discountPercent = item.percentageDiscount || 0;
                                const discountAmount = item.discount || item.discountAmount || 0;
                                const netAmount = item.amountDiscount || item.netAmount || 0;
                                const base = item.base || item.taxableAmount || 0;
                                const igv = item.igv || item.igvAmount || 0;
                                const total = item.total || item.totalWithIgv || 0;

                                return (
                                    <tr
                                        key={index}
                                        className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
                                    >
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-center">
                                            {sku}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-center">
                                            {productName}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-center">
                                            {unitName}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-center">
                                            {quantity}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-right">
                                            {Number(unitPrice).toFixed(2)}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-right">
                                            {Number(grossAmount).toFixed(2)}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-right">
                                            {Number(discountPercent).toFixed(2)}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-right">
                                            {Number(discountAmount).toFixed(2)}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-right">
                                            {Number(netAmount).toFixed(2)}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-right text-green-600 dark:text-green-400 font-semibold">
                                            {Number(base).toFixed(2)}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-right text-green-600 dark:text-green-400 font-semibold">
                                            {Number(igv).toFixed(2)}
                                        </td>
                                        <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle text-right text-green-600 dark:text-green-400 font-semibold">
                                            {Number(total).toFixed(2)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot className="bg-gray-50 dark:bg-gray-700/50">
                            <tr>
                                <td
                                    className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-200 dark:border-gray-600 align-middle text-right font-semibold"
                                    colSpan={9}
                                >
                                    Total
                                </td>
                                <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-200 dark:border-gray-600 align-middle text-right text-green-600 dark:text-green-400 font-bold">
                                    {totalBase.toFixed(2)}
                                </td>
                                <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-200 dark:border-gray-600 align-middle text-right text-green-600 dark:text-green-400 font-bold">
                                    {totalIgv.toFixed(2)}
                                </td>
                                <td className="px-3 py-2 text-xs whitespace-nowrap border-b border-gray-200 dark:border-gray-600 align-middle text-right text-green-600 dark:text-green-400 font-bold">
                                    {totalTotal.toFixed(2)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div className="flex justify-between items-center mt-4">
                    <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 text-sm font-medium px-4 py-2 transition-colors"
                        table="table-to-xls"
                        filename={filename}
                        sheet="report"
                        buttonText="Descargar como XLS"
                    />
                </div>
            </div>
        </WidgetModal>
    );
}
